
<div dwRow>
    <div dwCol="6">
        <ng-container *ngIf="showEdit && !readOnly">
            <label class="label">Section Name</label>
            <input type="text" [(ngModel)]="planOfActionSection.SectionName" (ngModelChange)="sectionTitleChange()" class="form-control" />
        </ng-container>
        <ng-container *ngIf="!showEdit || readOnly">
            <label class="label" *ngIf="showEdit">Section Name</label>
            <label class="label">{{showEdit ? planOfActionSection?.SectionName : sectionTitle}}</label>
        </ng-container>
    </div>
</div>
